import React from 'react'
import { Link, NavLink, useLocation } from 'react-router'

interface PersistedLinkProps {
    to: string
    children: React.ReactNode
    isNavLink?: boolean
    className?: string
    onClick?: () => boolean | void
}

const PersistedLink: React.FC<PersistedLinkProps> = ({ to, children, isNavLink, className, onClick }) => {
    const location = useLocation()
    const currentParams = new URLSearchParams(location.search)
    const [basePath, newQueryString] = to.split('?')
    const newParams = newQueryString ? new URLSearchParams(newQueryString) : new URLSearchParams()
    currentParams.forEach((value, key) => {
        if (!newParams.has(key)) {
            newParams.set(key, value)
        }
    })
    const newPath = newParams.size > 0 ? `${basePath}?${newParams.toString()}` : basePath

    const handleClick = (e: React.MouseEvent) => {
        if (onClick) {
            const shouldNavigate = onClick()
            if (shouldNavigate === false) {
                e.preventDefault()
                return
            }
        }
    }

    return isNavLink ? (
        <NavLink to={newPath} className={className} end onClick={handleClick}>
            {children}
        </NavLink>
    ) : (
        <Link to={newPath} className={className} onClick={handleClick}>
            {children}
        </Link>
    )
}

export default PersistedLink
